"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PusherEvent = void 0;
var PusherEvent;
(function (PusherEvent) {
    // User Events
    PusherEvent["BillingSuccessful"] = "billing_successful";
    PusherEvent["BillingUpdate"] = "billing_update";
    PusherEvent["BillingCancelled"] = "billing_cancelled";
    PusherEvent["BillingFailed"] = "billing_failed";
    // Document Status Events
    PusherEvent["Draft"] = "draft";
    PusherEvent["Archived"] = "archived";
    PusherEvent["Hardbounced"] = "hardbounced";
    PusherEvent["Importing"] = "importing";
    PusherEvent["Lost"] = "lost";
    PusherEvent["Processing"] = "processing";
    PusherEvent["Recalled"] = "recalled";
    PusherEvent["Rejected"] = "rejected";
    PusherEvent["Reviewed"] = "reviewed";
    PusherEvent["Scheduled"] = "scheduled";
    PusherEvent["Sealed"] = "sealed";
    PusherEvent["Sent"] = "sent";
    PusherEvent["Signed"] = "signed";
    PusherEvent["Signedwithoutverification"] = "signedwithoutverification";
    // Document Events
    PusherEvent["DocumentPageImageDone"] = "document_page_image_done";
    PusherEvent["DocumentPageImagesStarted"] = "document_page_images_started";
    PusherEvent["DocumentUpdated"] = "document_updated";
    PusherEvent["DownloadDocumentResponse"] = "download_document_response";
    PusherEvent["SealFailed"] = "seal_failed";
    PusherEvent["SealDone"] = "seal_done";
    PusherEvent["SealStatusUpdated"] = "seal_status_updated";
    PusherEvent["Deleted"] = "deleted";
    PusherEvent["Approved"] = "approved";
    PusherEvent["Viewed"] = "viewed";
    PusherEvent["Imported"] = "imported";
    PusherEvent["Converting"] = "converting";
    PusherEvent["Forwarded"] = "forwarded";
    PusherEvent["Comment"] = "comment";
    PusherEvent["Created"] = "created";
    PusherEvent["Expired"] = "expired";
    // Track Events
    PusherEvent["TrackClick"] = "track_click";
    PusherEvent["TrackPage"] = "track_page";
    PusherEvent["TrackVideo"] = "track_video";
    PusherEvent["TrackVisit"] = "track_visit";
    // E2E Event
    PusherEvent["Test"] = "test";
})(PusherEvent = exports.PusherEvent || (exports.PusherEvent = {}));
